/**
 * Branding utility to handle Thrana vs Vigilant branding
 * Based on REACT_APP_IS_VIGILANT_ENV environment variable
 */

// Import logos
import thranaLogo from '../assets/images/thrana.svg'
import vigilantLogo from '../assets/images/vigilantlabs.svg'

// Check if Vigilant environment is enabled
const isVigilantEnv = process.env.REACT_APP_IS_VIGILANT_ENV === 'true'

// Branding configuration
export const branding = {
  // Logo paths
  logo: isVigilantEnv ? vigilantLogo : thranaLogo,
  logoPath: isVigilantEnv ? '/assets/images/vigilantlabs.svg' : '/assets/images/thrana.svg',
  
  // Product name
  productName: isVigilantEnv ? 'Vigilant.ai' : 'Thrana',
  
  // Company name
  companyName: isVigilantEnv ? 'Vigilant Labs' : 'Thrana Softech Pvt. Ltd.',
  
  // Company website
  companyWebsite: isVigilantEnv ? 'https://vigilantlabs.ai' : 'https://thranatech.com',
  
  // Favicon
  favicon: isVigilantEnv ? 'VigilantFavicon.ico' : 'ThranaFavicon.ico',
  
  // Environment flag
  isVigilant: isVigilantEnv,
}

export default branding
